export const getKuImage = (imgNum: number) => {
  switch (imgNum) {
    case 1:
      return "OUlf7Auh"
    case 2:
      return "aRxNTDOh"
    case 3:
      return "vAEj4tqh"
    case 4:
      return "coMDEi9h"
    case 5:
      return "EBC6YEgh"
    case 6:
      return "gvp993Gh"
    case 7:
      return "szvF2hhh"
    case 8:
      return "XIwEINyh"
    case 9:
      return "YwE6MWLh"
    case 10:
      return "tzXjuDdh"
    case 11:
      return "bY73lPph"
    case 12:
      return "KkoTWP4h"
    case 13:
      return "C15eUajh"
    case 14:
      return "ohxHWx2h"
    case 15:
      return "hGJDnEwh"
    case 16:
      return "QUx6K3oh"
    case 17:
      return "NFwqi19h"
    case 18:
      return "hMKNXQ4h"
    case 19:
      return "Zrz0L7Rh"
    case 20:
      return "J7g4MAbh"
    case 21:
      return "u6iPW2Xh"
    case 22:
      return "6HmZoyDh"
    case 23:
      return "fKDlClDh"
    case 24:
      return "qrQnAvRh"
    case 25:
      return "ndlNkjuh"
    case 26:
      return "TWDpiCkh"
    case 27:
      return "DwrP4Boh"
    case 28:
      return "AAC4yFsh"
    case 29:
      return "KAxdyClh"
    case 30:
      return "vN3PEvXh"
    case 31:
      return "jwM1CVfh"
    case 32:
      return "cK1Wk6Ih"
    case 33:
      return "38B5owVh"
    case 34:
      return "6Mf9KTsh"
    case 35:
      return "NsYTtEoh"
    case 36:
      return "06wuC4Xh"
    case 37:
      return "vzJWT08h"
    case 38:
      return "D9GHOeSh"
    case 39:
      return "0NHaRAPh"
    case 40:
      return "QV1qyqKh"
    case 41:
      return "fkwxCeuh"
    case 42:
      return "6P1HlQWh"
    case 43:
      return "z5fbDWah"
    case 44:
      return "JX46aERh"
    case 45:
      return "yXozF7sh"
    case 46:
      return "Y17RNFth"
    case 47:
      return "rJdExXBh"
    case 48:
      return "mfvmpaSh"
    case 49:
      return "L4H1aBGh"
    case 50:
      return "xwzPdKih"
    case 51:
      return "8B3JgpVh"
    case 52:
      return "sDACPUuh"
    case 53:
      return "W6d0hzIh"
    case 54:
      return "gYgM5fFh"
    case 55:
      return "mAIYFvCh"
    case 56:
      return "JMPJoesh"
    case 57:
      return "k0GGcxBh"
    case 58:
      return "5EMuxQIh"
    case 59:
      return "3pQvgV3h"
    case 60:
      return "LtQPK0lh"
    case 61:
      return "Ld8MbRhh"
    case 62:
      return "c6ol8V5h"
    case 63:
      return "YKWH3cgh"
    case 64:
      return "WTf3YvJh"
    case 65:
      return "8lUF2Jqh"
    case 66:
      return "mJjT0sHh"
    case 67:
      return "7VR2VFih"
    case 68:
      return "pBkAkV2h"
    case 69:
      return "Dg47lbVh"
    case 70:
      return "owe7AFxh"
    case 71:
      return "BKU7VTmh"
    case 72:
      return "NfrBg1oh"
    case 73:
      return "aMrveZeh"
    case 74:
      return "fyW18Deh"
    case 75:
      return "y8r2Qv7h"
    case 76:
      return "iy9WfpBh"
    case 77:
      return "kptyOShh"
    case 78:
      return "7GzLuJ3h"
    case 79:
      return "R7M8PsZh"
    case 80:
      return "WdNLQPbh"
    case 81:
      return "tUxVKsTh"
    case 82:
      return "53AdD21h"
    case 83:
      return "PzsjZC0h"
    case 84:
      return "BI1ZqM2h"
    case 85:
      return "I9YDWbFh"
    case 86:
      return "srOnpW9h"
    case 87:
      return "k4EjaNIh"
    case 88:
      return "tRILFqTh"
    case 89:
      return "Ouo51x8h"
    case 90:
      return "fJiaFGGh"
    case 100:
      return "JFvDgZ7h"
    case 101:
      return "XWF2qpuh"
    case 102:
      return "ZCbhFlRh"

    default:
      return "ZCbhFlRh"
  }
}
